import { create } from 'zustand';

export type CodeInfo = {
  groupCode: string;
  codeId: number;
  code: string;
  codeName: string;
  isActive: boolean;
};

interface CodeState {
  codes: CodeInfo[];
  setCodes: (codes: CodeInfo[]) => void;
}

const useCodeStore = create<CodeState>(set => ({
  codes: [],
  setCodes: codes => set({ codes }),
}));

export default useCodeStore;